Application.Customize = {
    ui: {
        form: '.js-form--customize',
        submit: '.js-form__submit',
        back: '.js-form__back',
        field: '.js-form__field',
        slider: '.js-form__field-slider',
        rentPerEmployee: '.js-form__rent-per-employee',
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.form).length){
            return;
        }

        // validate
        $(this.ui.field).add(this.ui.slider).change(function(e){
            self.setSubmitState(self.isValid());
            self.updateRentPerEmployee();
        });
        self.updateRentPerEmployee();

        // submit
        $(this.ui.submit).click(function(e){
            e.preventDefault();
            self.submit($(this).closest(self.ui.form).attr('action'), $(this).attr('href'));
        });

        // back
        $(this.ui.back).click(function(){
            self.showLoader();
        });

    },
    submit: function (action, next) {

        if (!this.isValid()){
            return false;
        }

        this.showLoader();

        $.post(action, this.getData(), function(data){
            if (data.result){
                // all done, go to next step
                window.location.href = next;
            }
        }, 'json');

    },
    setSubmitState: function(enabled){

        if (enabled){
            $(this.ui.submit).removeClass('disabled');
        }else{
            $(this.ui.submit).addClass('disabled');
        }

    },
    getData: function(){

        var self = this;
        var data = {};

        $(this.ui.field).each(function(){
            var name = $(this).attr('name');
            if ($(this).is('[type="radio"]')){
                data[name] = $(self.ui.field).filter('[name="' + name + '"]:checked').val();
            } else if ($(this).is('[type="checkbox"]')){
                data[name] = $(this).is(':checked') ? 1 : 0;
            }else{
                data[name] = $(this).val();
            }
        });

        return data;

    },
    isValid: function(){

        var data = this.getData();

        if (!data.gva){
            return false;
        }

        if (!data.country_average_wage){
            return false;
        }

        if (!data.headline_rent){
            return false;
        }

        if (!data.area_per_one_employee){
            return false;
        }

        return true;

    },
    updateRentPerEmployee: function(){

        var data = this.getData();

        var rent = data.headline_rent * data.area_per_one_employee * 12;

        $(this.ui.rentPerEmployee).text(rent);

    },
    showLoader: function(){

        $('body').addClass('loading');

    }
};